// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JT4FGI4B5j7Mt8 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  color: #ffffff;
}
.mteCtehxBR9dEC {
  max-width: 800px;
  margin-top: 56px;
  padding: 0 24px;
  font-size: 40px;
  line-height: 48px;
}
.bfROFqkjIRuxhk {
  flex-grow: 1;
  max-width: 560px;
  margin-bottom: 24px;
  padding: 0 24px;
  font-size: 20px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 24px;
}
.bfROFqkjIRuxhk.KEXF9GUhLwTU_h {
  margin-bottom: 56px;
}
.TW1rM28eCkHPN7 {
  display: flex;
  align-items: center;
}
.TW1rM28eCkHPN7 img {
  max-width: 100%;
  max-height: 68dvh;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `JT4FGI4B5j7Mt8`,
	"heading": `mteCtehxBR9dEC`,
	"subheading": `bfROFqkjIRuxhk`,
	"spaceForContinueButton": `KEXF9GUhLwTU_h`,
	"lottieFallback": `TW1rM28eCkHPN7`
};
export default ___CSS_LOADER_EXPORT___;
